export enum Collection {
	GiftCards = 'GiftCards',
	Cuisines = 'Cuisines',
}
